/* @flow */

import * as React from 'react';
import { connect } from 'react-redux';
import styled from '@emotion/styled';
import { padding } from 'polished';
import t from 'app/utils/translate';
import Modal from 'app/components/commons/Modal';
import Title from 'app/components/commons/Title';
import Button from '../commons/Button';
import Loader from '../commons/Loader';

type Props = {
  children?: any,
  onConfirm?: () => void,
  onClose: () => void,
  isLoading?: boolean,
  isLineup?: boolean,
  submittingIsSlow?: boolean,
  title: string,
  topMessageRender?: () => any,
};

const defaultProps = {
  children: undefined,
  isLoading: false,
  isLineup: false,
  onConfirm: undefined,
  submittingIsSlow: false,
  topMessageRender: () => null
};

const Detail = styled.div(({ theme }) => ({
  color: theme.color.basis2,
  fontSize: '1.125em',
  ...padding(theme.spacing.default, 0)
}));

const ModalContent = styled.div(({ theme }) => ({
  backgroundColor: theme.color.white,
  borderRadius: 6,
  color: theme.color.basis9,
  ...padding('1rem', '1.5rem', '0.75rem'),
  position: 'relative',
  textAlign: 'center',
  top: 0,
  marginTop: '90px'
}));

const Stack = styled.div(
  {
    display: 'flex',
    flexDirection: 'column',
    margin: '0 auto'
  },
  ({ theme }) => ({
    [theme.mediaQuery.desktopAndUp]: {
      maxWidth: 350
    }
  })
);

const CancelButton = styled(Button)({
  marginTop: 10
});

function ChallengeConfirmationModal({
  children,
  isLoading,
  onClose,
  onConfirm,
  submittingIsSlow,
  title,
  isLineup,
  topMessageRender = defaultProps.topMessageRender
}: Props) {
  return (
    <Modal bare isOpen onCancel={onClose} size="medium">
      <ModalContent>
        {topMessageRender()}
        <Title noWhiteSpace>{title}</Title>
        <Detail>
          {children}
          {isLoading && (
            <React.Fragment>
              <Loader kind="dark" />
              {submittingIsSlow ? (
                <span>
                  {t(
                    "Sorry about the wait, we're under high demand at the moment and are still working on it, we promise!"
                  )}
                </span>
              ) : (
                <span>
                  {t(
                    `Please wait, we're currently submitting your ${isLineup ? 'lineup' : 'entry'}`
                  )}
                  ...
                </span>
              )}
            </React.Fragment>
          )}
        </Detail>
        <Stack>
          <Button kind="primary" size="medium" onClick={onConfirm} disabled={isLoading}>
            {t('Confirm')}
          </Button>
          <CancelButton kind="cancel" size="medium" onClick={onClose}>
            {t('Cancel')}
          </CancelButton>
        </Stack>
      </ModalContent>
    </Modal>
  );
}

ChallengeConfirmationModal.defaultProps = defaultProps;

function mapStateToProps({ settings }) {
  return {
    displayFacebook: settings.social.displayFacebook,
    displayTwitter: settings.social.displayTwitter,
    isNativeApp: settings.nativeApp
  };
}

export default connect(mapStateToProps)(ChallengeConfirmationModal);
